import {
    Box,
    Stack,
    Heading,
    Text,
    Card,
    Container,
    CardBody,
    StackDivider
} from '@chakra-ui/react'
import DashboardChildrenSection from './_components/DashboardChildrenSection'
import { useAuth } from '@/shared/context/AuthContext'
import { Navigate } from 'react-router-dom'
import EmptyTableState from '@/components/datatable/EmptyTableState'
import { PROTECTED_ROUTES } from '@/shared/config/routes'
import { ProtectedPage } from '@/shared/components/ProtectedPage'

export default function ParentHome() {
    const { user } = useAuth()
    const data = user
    const subData = data?.parent ? data.parent : data
    // TODO: on next line, "parentData" isn't any! It is just quick fix
    // for lint errors on Login Refactor
    const parentData: any = {
        firstName: data?.firstName,
        lastName: data?.lastName,
        ...subData
    }

    if (parentData?.parent === null) return <Navigate to="/user/teacher" replace />


    return (
        <ProtectedPage routeConfig={PROTECTED_ROUTES['/user/parent']}>
            <Box
                minH={['container.sm', 'container.md']}
                borderRadius={4}
                bg={'white'}
                mx={'auto'}
                pt={5}
                px={{ base: 2, md: 17 }}
            >
                <Box p={4}>
                    <Stack spacing={4} as={Container} maxW={'full'}>
                        <Heading
                            fontSize={{ base: '3xl', sm: '3xl' }}
                            fontWeight={'bold'}
                        >
                            Parent Dashboard
                        </Heading>
                        <Text color={'gray.600'} fontSize={{ base: 'sm', sm: 'lg' }}>
                            Welcome dear parent, we log your check-in and check-out
                            information on this page
                        </Text>
                        <Card
                            mt={4}
                            variant={'outline'}
                            width="fit-content"
                            direction={{ base: 'column', sm: 'row' }}
                        >
                            <CardBody>
                                <Stack
                                    direction={['column', 'row']}
                                    divider={<StackDivider />}
                                    spacing="4"
                                >
                                    <Box>
                                        <Text
                                            py="2"
                                            color={'gray.600'}
                                            fontSize="xs"
                                            textTransform="uppercase"
                                        >
                                            Name
                                        </Text>
                                        <Heading size="xs">
                                            {parentData?.firstName} {parentData?.lastName}
                                        </Heading>
                                    </Box>
                                    <Box>
                                        <Text
                                            py="2"
                                            color={'gray.600'}
                                            fontSize="xs"
                                            textTransform="uppercase"
                                        >
                                            Relationship
                                        </Text>
                                        <Heading size="xs">
                                            {parentData?.relationship}
                                        </Heading>
                                    </Box>
                                    <Box>
                                        <Text
                                            py="2"
                                            color={'gray.600'}
                                            fontSize="xs"
                                            textTransform="uppercase"
                                        >
                                            Email
                                        </Text>
                                        <Heading size="xs">{parentData?.email}</Heading>
                                    </Box>
                                    <Box>
                                        <Text
                                            py="2"
                                            color={'gray.600'}
                                            fontSize="xs"
                                            textTransform="uppercase"
                                        >
                                            Phone Number
                                        </Text>
                                        <Heading size="xs">
                                            {parentData?.phoneNumber}
                                        </Heading>
                                    </Box>
                                    <Box>
                                        <Text
                                            py="2"
                                            color={'gray.600'}
                                            fontSize="xs"
                                            textTransform="uppercase"
                                        >
                                            Church Branch
                                        </Text>
                                        <Heading size="xs">
                                            {parentData?.branch?.name}
                                        </Heading>
                                    </Box>
                                </Stack>
                            </CardBody>
                        </Card>
                    </Stack>
                    <DashboardChildrenSection />
                    {/* table section */}
                    <Stack spacing={4} as={Container} maxW={'full'}>
                        <Heading
                            fontSize={{ base: '2xl', sm: '2xl' }}
                            fontWeight={'bold'}
                        >
                            History
                        </Heading>
                        <Text color={'gray.600'} fontSize={{ base: 'sm', sm: 'lg' }}>
                            Logs of your children check-in and check-out
                        </Text>
                    </Stack>
                    <EmptyTableState
                        title={'Data coming soon'}
                        message={
                            ' No data available at the moment. The team is working on this.'
                        }
                    />
                </Box>
            </Box>
        </ProtectedPage>
    )
}
